@if (isLoading) {
  <nz-spin nzSimple />
} @else if (failed) {
  <p>Daten konnten nicht geladen werden.</p>
} @else if (!items.length) {
  <nz-empty nzNotFoundContent="Keine offenen Produkte" />
} @else {
  <nz-table
    #setupsTable
    [nzData]="items"
    [nzFrontPagination]="false"
    nzSize="small"
    >
    <thead>
      <tr>
        <th>Produkt</th>
        <th>Nächster Schritt</th>
        <th>Vorgesehen</th>
        <th>Wartet</th>
      </tr>
    </thead>
    <tbody>
      @for (row of setupsTable.data; track row.setupId) {
        <tr>
          <td>
            <a routerLink="/product-setups" [queryParams]="{ setupId: row.setupId }">{{ row.productName }}</a>
          </td>
          <td>{{ row.stepLabel }}</td>
          <td>{{ row.foreseenName || '–' }}</td>
          <td class="white-space-no-wrap">{{ waiting(row.waitingSince) }}</td>
        </tr>
      }
    </tbody>
  </nz-table>

  <div>
    <a routerLink="/product-setups">Alle anzeigen</a>
  </div>
}
